import { render, staticRenderFns } from "./ExternalPage.vue?vue&type=template&id=bd43dbf0&scoped=true&"
import script from "./ExternalPage.vue?vue&type=script&lang=js&"
export * from "./ExternalPage.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPage.vue?vue&type=style&index=0&id=bd43dbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43dbf0",
  null
  
)

export default component.exports